export default "__VITE_ASSET__COp088ek__"